// Słownik ekranu „Rozmowy": pasek filtrów, tabela, szuflada szczegółów (nagranie, transkrypcja,
// adnotacje) i eksporty.
//
// Konwencja komentarzy: `// VERIFY: ...` = tłumaczenie własne (brak w mockupie albo inny układ),
// brak komentarza = tekst z design/voicesphere-dashboard.html.
export default {
  toolbar: {
    searchPlaceholder: 'Szukaj po numerze lub treści…',
    allTopics: 'Wszystkie tematy',
    exportCsv: 'Eksport CSV',
    // VERIFY: cały blok, brak w mockupie (mockup ma tylko 4 chipy, wybór tematu i eksport).
    exportTooltip: 'Przygotuj i pobierz historię rozmów z wybranego okresu.',
    refresh: 'Odśwież',
    trendingTopics: 'Popularne tematy:',
    noTrendingTopics: 'Brak popularnych tematów do wyświetlenia',
    // Chip „Wszystkie" bierze się z common:states.all, „Rozwiązane" z status.resolved.
    // VERIFY: mockup ma chip „Przekazane" (wszystko, co poszło do urzędnika), a nasz filtr
    // wybiera tylko rozmowy odebrane przez urzędnika (`agent=true`), stąd inna nazwa.
    clerkChip: 'Odebrane przez urzędnika',
    // VERIFY: cały blok, brak w mockupie (11 filtrów w panelu „Więcej filtrów").
    aria: {
      topic: 'temat',
      type: 'typ rozmowy',
      agent: 'obsługa',
      status: 'status',
      language: 'język',
    },
    placeholders: {
      type: 'Typ rozmowy',
      agent: 'Obsługa',
      status: 'Status',
      language: 'Język',
    },
  },

  // Etykiety wartości `status` z API (wartość w logice zostaje angielska).
  status: {
    // VERIFY: „Na żywo" brak w mockupie (mockup nie ma rozmów w toku).
    live: 'Na żywo',
    resolved: 'Rozwiązane',
  },

  // VERIFY: cały blok, opcje filtrów spoza mockupu. Klucze to wartości API.
  filters: {
    type: {
      TextConversation: 'SMS',
      AnalyticsCall: 'Rozmowa AI',
      AgentCall: 'Rozmowa z urzędnikiem',
      ChatConversation: 'Chatbot',
      EmailConversation: 'E-mail',
    },
    agent: {
      ai: 'AI',
      human: 'Urzędnik',
    },
    language: {
      'en-us': 'Angielski',
      'es-mx': 'Hiszpański',
    },
  },

  table: {
    columns: {
      number: 'Numer',
      dateTime: 'Data i godzina',
      topic: 'Temat',
      summary: 'Streszczenie',
      duration: 'Czas',
      rating: 'Ocena',
      status: 'Status',
    },
    empty: 'Brak rozmów spełniających kryteria.',
    // VERIFY: cały blok, brak w mockupie.
    flagAlt: 'Flaga',
    smsSummarySent: 'Wysłano wiadomość SMS z podsumowaniem.',
    liveDuration: 'NA ŻYWO',
    playRecording: 'Odtwórz nagranie',
    pauseRecording: 'Wstrzymaj nagranie',
    // Etykieta rozmowy wychodzącej (kampania lub rozmowa testowa) przy numerze.
    outbound: 'Wychodząca',
  },

  drawer: {
    // VERIFY: mockup tytułuje szufladę pierwszą wypowiedzią, my tematami rozmowy.
    fallbackTitle: 'Rozmowa',
    meta: {
      number: 'Numer:',
      date: 'Data:',
      duration: 'Czas:',
      minutes: '{{length}} min',
    },
    sections: {
      aiSummary: 'Podsumowanie AI',
      caseData: 'Dane sprawy',
      transcript: 'Transkrypcja',
      // VERIFY: sekcje spoza mockupu.
      annotations: 'Adnotacje do fragmentów',
      smsSummary: 'Wiadomość SMS z podsumowaniem',
    },
    // VERIFY: cały blok, brak w mockupie (mockup ma tylko odtwarzacz z syntezą mowy).
    recording: {
      unavailable: 'Nagranie rozmowy jest niedostępne',
      processing: 'Nagranie jest przetwarzane',
      callDuration: 'Czas rozmowy:',
      connectAgent: 'Przekazanie do urzędnika:',
      aiCall: 'Rozmowa AI',
      downloadTxt: 'Pobierz jako txt',
      downloadAudio: 'Pobierz nagranie',
      copyLink: 'Kopiuj link',
    },
    // VERIFY: cały blok, stany puste i ładowania spoza mockupu.
    noSummary: 'Dla tej rozmowy nie wygenerowano streszczenia.',
    translationLoading: 'Ładowanie tłumaczenia…',
    transcriptUnavailable: 'Transkrypcja niedostępna',
    markReviewed: 'Oznacz rozmowę jako sprawdzoną',
    transcript: {
      start: 'Początek rozmowy',
      end: 'Koniec rozmowy',
      keywordDetected: 'Wykryte słowo kluczowe:',
      document: 'Dokument:',
    },
    annotations: {
      label: 'Adnotacja do tego fragmentu',
      placeholder: 'Dodaj komentarz',
      add: 'Dodaj adnotację',
    },
    toast: {
      txtDownloaded: 'Plik został pobrany',
      txtFailed: 'Nie udało się pobrać transkrypcji',
      linkCopied: 'Link został skopiowany',
      linkFailed: 'Nie udało się skopiować linku',
      audioDownloaded: 'Plik audio został pobrany',
      audioFailed: 'Nie udało się pobrać pliku audio',
    },
    facts: {
      category: 'Kategoria',
      department: 'Wydział',
      residentRating: 'Ocena mieszkańca',
      callTime: 'Pora połączenia',
      notRated: 'nie wystawiono',
      ratingOutOfFive: '{{score}} / 5',
      duringOfficeHours: 'w godzinach pracy',
      outsideOfficeHours: 'poza godzinami pracy',
      // VERIFY: kafelki i stany spoza mockupu (mockup nie ma identyfikatora rozmowy ani
      // rozróżnienia „nie przekazano" / „nieznany wydział").
      callId: 'Identyfikator rozmowy',
      notRecorded: 'brak zapisu',
      notHandedOff: 'nie przekazano',
      unknownDepartment: 'Nieznany wydział',
      uncategorised: 'Bez kategorii',
    },
  },

  export: {
    // VERIFY: cały blok, brak w mockupie (mockup pobiera CSV od razu, my mamy historię eksportów).
    prepare: 'Przygotuj eksport',
    noData: 'Brak danych do eksportu dla wybranego okresu.',
    history: 'Historia eksportów',
    statusHeading: 'Status',
    // Etykiety wartości `status` raportu z API.
    status: {
      pending: 'W trakcie',
      complete: 'Gotowy',
    },
    empty: 'Brak wyeksportowanych plików do wyświetlenia',
    limitToast: 'Osiągnięto limit eksportów. Rozpoczęto czas oczekiwania.',
    limitInfo: 'Osiągnięto limit 4 eksportów. Odczekaj 2 minuty.',
    fileDownloaded: 'Plik został pobrany.',
    fileNoLink: 'Nie znaleziono linku do pobrania pliku',
  },

  // Komunikaty ekranu (toasty). Tekst z backendu ma pierwszeństwo, tu są tylko zapasowe.
  // VERIFY: cały blok, brak w mockupie.
  messages: {
    recordingUnavailable: 'To nagranie jest niedostępne.',
    recordingProcessing: 'To nagranie jest jeszcze przygotowywane. Spróbuj ponownie za minutę.',
    exportProcessing: 'Przetwarzanie pliku…',
    exportFailed: 'Nie udało się wyeksportować rozmów',
    exportNotStarted: 'Eksport nie rozpoczął się. Spróbuj ponownie.',
    exportStillProcessing:
      'Ten eksport nadal jest przetwarzany. Można go usunąć i spróbować ponownie.',
    exportStatusCheckFailed:
      'Nie udało się sprawdzić statusu eksportu. Odśwież stronę, aby sprawdzić ponownie.',
  },

  // Etykiety typu rozmowy (STI z API) w karcie sesji i w historii. Klucze to wartości API.
  // VERIFY: cały blok, brak w mockupie.
  channels: {
    ChatConversation: 'Czat',
    ElevenLabsCall: 'Rozmowa AI',
    AnalyticsCall: 'Rozmowa głosowa',
    AgentCall: 'Rozmowa z urzędnikiem',
    TextConversation: 'SMS',
    EmailConversation: 'E-mail',
    unknown: 'Rozmowa',
  },
} as const;
